import React from 'react';
import ReactDOM from 'react-dom/client';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from "@azure/msal-react";
import App from './App';
import { msalConfig } from './authConfig';
import { BrowserRouter } from 'react-router-dom';
import 'primereact/resources/themes/lara-light-blue/theme.css'; // Choose a theme
import 'primereact/resources/primereact.min.css'; // PrimeReact styles
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css'; // Add PrimeFlex CSS


// Initialize MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL and render the app
const initializeApp = async () => {
  await msalInstance.initialize();

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </MsalProvider>
    </React.StrictMode>
  );
};

initializeApp().catch(error => {
  console.error("Failed to initialize app:", error);
});